import searchMixin from '@com/mixin/search.js'

export default searchMixin
